import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

const SECRET_KEY = 'YOUR_SECRET_KEY_123'; // keep in environment ideally

@Injectable({
  providedIn: 'root',
})
export class Storage {
  // =====================================
  // ENCRYPT
  // =====================================
  private encrypt(value: any): string {
    return CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
  }

  // =====================================
  // DECRYPT
  // =====================================
  private decrypt(value: string): any {
    const bytes = CryptoJS.AES.decrypt(value, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  }

  // =====================================
  // STORE (ALL ENCRYPTED)
  // =====================================
  store(key: string, value: any): void {
    const encrypted = this.encrypt(value);
    localStorage.setItem(key, encrypted);
  }

  // =====================================
  // RETRIEVE (ALL DECRYPTED)
  // =====================================
  retrieve(key: string): any {
    const data = localStorage.getItem(key);
    if (!data) return null;

    try {
      return this.decrypt(data);
    } catch {
      return null;
    }
  }

  // =====================================
  // REMOVE
  // =====================================
  remove(key: string): void {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }

  // =====================================
  // CLEAR
  // =====================================
  clear(): void {
    localStorage.clear();
    sessionStorage.clear();
  }

  // =====================================
  // SESSION TOKEN ONLY
  // =====================================
  setSession(key: string, value: string): void {
    sessionStorage.setItem(key, value);
    localStorage.setItem(key, value);
  }

  getSession(key: string): string | null {
    const value = sessionStorage.getItem(key) || localStorage.getItem(key);
    if (value && !sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, value);
    }
    return value;
  }
}

/* The Storage class in TypeScript provides methods for storing, retrieving, removing, and clearing
data in the browser's localStorage. */
// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class Storage {

//   /* SAVE */
//   store(key: string, value: any): void {
//     if (typeof value === 'string') {
//       localStorage.setItem(key, value);   // 🔥 image, token
//     } else {
//       localStorage.setItem(key, JSON.stringify(value)); // user object
//     }
//   }

//   /* GET */
//   retrieve(key: string): any {
//     const data = localStorage.getItem(key);
//     if (!data) return null;

//     try {
//       return JSON.parse(data); // object
//     } catch {
//       return data; // string
//     }
//   }

//   remove(key: string): void {
//     localStorage.removeItem(key);
//   }

//   clear(): void {
//     localStorage.clear();
//   }
// }
